import { gql } from '@apollo/client';

export const ASSIGN_CLINICAL_USERS = gql`
  mutation AssignClinicalUsers(
    $clinicalUsersId: [Float!]!
    $providerId: Float!
  ) {
    assignClinicalUsers(
      clinicalUsersId: $clinicalUsersId
      providerId: $providerId
    ) {
      id
    }
  }
`;
